export default "__VITE_ASSET__5c84eef9__"